import { EGroupedItemsType } from '~/src/services/properties';

export const tabColumnConfig = {
    label: {
        label: 'Заголовок',
        type: EGroupedItemsType.Title,
        name: 'label',
    },
    properties: {
        name: 'properties',
        items: {
            background: {
                name: 'background',
                label: 'Фон',
                type: EGroupedItemsType.File,
            },
            backgroundWebp: {
                name: 'webp',
                type: EGroupedItemsType.Hidden,
            },
            backgroundColor: {
                name: 'backgroundColor',
                label: 'Цвет фона',
                type: EGroupedItemsType.ColorPicker,
            },
            backgroundColorMobile: {
                name: 'backgroundColorMobile',
                label: 'Цвет фона текстового блока (мобилка)',
                type: EGroupedItemsType.ColorPicker,
            },
        },
    },
};
